import request from '@/common/request'

class ItensVOService {
  getAll(params) {
    return request.get('/itens-vo', {
      params
    })
  }

  getItens() {
    return request.get('/itens-vo/opcoes')
  }

  create(data) {
    return request.post('/itens-vo', data)
  }

  update(id, data) {
    return request.patch(`/itens-vo/${id}`, data)
  }

  multiUpdate(data) {
    return request.put('/itens-vo', data)
  }

  deleteById(id) {
    return request.delete(`/itens-vo/${id}`)
  }

  getIcmsRelacionados(id) {
    return request.get(`/itens-vo/${id}/icms`)
  }

  buscarIcmsAtual(itemVoId) {
    return request.get(`/itens-vo/${itemVoId}/icms/vigente`)
  }

  removerIcmsVigente(itemVoId, icmsId) {
    return request.delete(`/itens-vo/${itemVoId}/icms/${icmsId}`)
  }

  removerValorPropriedade(itemVoId, propriedade) {
    return request.delete(`/itens-vo/${itemVoId}/propriedades/${propriedade}`)
  }
}

export default new ItensVOService()
